import React, { memo } from 'react'

import GenericPolyCountSelector from 'Pods/ThreeDStudio/Shared/GenericPolyCountSelector/GenericPolyCountSelector'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'
import { setPolyCount, setTargetPolycount } from 'Pods/ThreeDStudio/Store/actions/modelSettings'
import { POLY_COUNT } from 'Pods/ThreeDStudio/Store/constants'

const handleLowClick = (skipSelectedUseCaseUpdate = false) => (
  setPolyCount(POLY_COUNT.LOW, skipSelectedUseCaseUpdate)
)
const handleMediumClick = (skipSelectedUseCaseUpdate = false) => (
  setPolyCount(POLY_COUNT.MEDIUM, skipSelectedUseCaseUpdate)
)
const handleHighClick = (skipSelectedUseCaseUpdate = false) => (
  setPolyCount(POLY_COUNT.HIGH, skipSelectedUseCaseUpdate)
)

function PolyCountSelector() {
  const isSmartLowPoly = useThreeDStudioStore(state => state.modelSettings.isSmartLowPoly)

  return (
    <GenericPolyCountSelector
      handleLowClick={handleLowClick}
      handleMediumClick={handleMediumClick}
      handleHighClick={handleHighClick}
      setTargetPolycount={setTargetPolycount}
      sliceName="modelSettings"
      storeSchemaKey="generationModelSchema"
      forceDisabled={isSmartLowPoly}
    />
  )
}

export default memo(PolyCountSelector)
